import axios from '../utils/axios';

export default function getUserProfile(adminId,params) {
    return (
        axios.get('/recruiter')
        .then(res => {
            return res.data;
        })
        .catch(err => {
            return err;
        })
    )
}
